/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import hasOwnProperty from './helpers/hasOwnProperty';

function setProperty<
  T extends ObjectOf<any>,
  K extends keyof T,
  V extends T[K]
>(object: T, propName: K, update?: V | ((oldValue: V) => V)): T {
  let oldValue = object[propName];
  let newValue =
    typeof update === 'function'
      ? // @ts-ignore
        update(oldValue)
      : update;
  if (newValue === oldValue) {
    return object;
  }
  let newObject: T = Object.assign({}, object);
  newObject[propName] = newValue;
  return newObject;
}

function setProperties<T extends ObjectOf<any>>(
  object: T,
  updates: Partial<T>,
): T {
  let newObject: Partial<T> | null = null;
  Object.keys(updates).forEach((key: keyof T) => {
    let oldValue = object[key];
    let newValue = updates[key];
    if (oldValue !== newValue) {
      newObject = newObject || Object.assign({}, object);
      newObject[key] = newValue;
    }
  });
  return (newObject || object) as T;
}

function deleteProperty<T extends ObjectOf<any>>(
  object: T,
  keyToDelete: keyof T,
): T {
  if (!hasOwnProperty(object, keyToDelete as string)) {
    return object;
  }
  let newObject: Partial<T> = {};
  Object.keys(object).forEach((key: keyof T) => {
    if (key !== keyToDelete) {
      newObject[key] = object[key];
    }
  });
  return newObject as T;
}

function appendElement<T>(array: Array<T>, element: T): Array<T> {
  let newArray = array.slice();
  newArray.push(element);
  return newArray;
}

function replaceElement<T>(
  array: Array<T>,
  index: number,
  update: T | ((el: T) => T),
): Array<T> {
  let oldElement = array[index];
  let newElement =
    typeof update === 'function'
      ? // @ts-ignore
        update(oldElement)
      : update;
  if (newElement === oldElement) {
    return array;
  }
  let newArray = array.slice();
  newArray[index] = newElement;
  return newArray;
}

function removeElement<T>(array: Array<T>, element: T): Array<T> {
  let index = array.indexOf(element);
  if (index === -1) {
    return array;
  }
  let newArray = array.slice();
  newArray.splice(index, 1);
  return newArray;
}

export {
  setProperty,
  setProperties,
  deleteProperty,
  appendElement,
  replaceElement,
  removeElement,
};

export default {
  setProperty,
  setProperties,
  deleteProperty,
  appendElement,
  replaceElement,
  removeElement,
};
